import { j as l } from "../../jsx-runtime-B6kdoens.js";
import { useContext as R, useMemo as d } from "react";
import { c as j, f as B } from "../../create-component-CBAeEoQ6.js";
import { CheckboxBase as b } from "../Checkbox/index.js";
import { u as h } from "../../use-unique-id-BA9hSqap.js";
import { F as k } from "../../FormControlContext-C7A4R-3o.js";
const y = j(
  "RadioButton",
  B(
    ({ checked: u, id: p, name: i, onChange: t, size: s, state: e, value: m, ...f }, c) => {
      const o = R(k), x = h("radio-button", p);
      i = i || o.name, s = s || o.size, e = e || o.state;
      const n = d(
        () => t || o.onChange ? (r) => {
          var a;
          t == null || t(r, r.target.value), (a = o.onChange) == null || a.call(o, r, r.target.value);
        } : void 0,
        [t, o]
      ), C = d(() => u || (n ? o.value === m : void 0), [u, n, m, o.value]);
      return /* @__PURE__ */ l.jsx(
        b,
        {
          id: x,
          name: i,
          size: s,
          state: e,
          onChange: n,
          checked: C,
          value: m,
          ...f,
          type: "radio",
          ref: c
        }
      );
    }
  )
);
export {
  y as RadioButton
};
//# sourceMappingURL=index.js.map
